export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/components/app-sidebar/index.ts